/*
 * @Author: Teemo Ding
 * @Date: 2022-04-14 17:07:31
 * @LastEditTime: 2022-04-14 17:07:32
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/types/common/permission.ts
 */
export enum IInviteUserType {
  Email = 'Email',
  Mobile = 'Mobile',
}

export enum UserStatus {
  Invited = 'Invited',
  Registered = 'Registered',
}
